import {inject, Injectable} from '@angular/core';
import {map} from 'rxjs';
import {AppStore} from '../store/app.store';
import {BaseApiService} from './base-api.service';

@Injectable({
  providedIn: 'root'
})
export class LookupSizeService extends BaseApiService {
  private appStore = inject(AppStore);


  getWidths(category: string | null) {
    return this.get<{data: string[]}>(`clients/${this.appStore.client_id()}/sizes/tires/widths`, {category}).pipe(
      map(response => response.data)
    );
  }

  getRatios(width: string, category: string | null) {
    return this.get<{data: string[]}>(`clients/${this.appStore.client_id()}/sizes/tires/widths/${width}/aspect-ratios`, {category}).pipe(
      map(response => response.data)
    );
  }

  getRimDiameters(width: string, ratio: string, category: string | null) {
    return this.get<{data: string[]}>(`clients/${this.appStore.client_id()}/sizes/tires/widths/${width}/aspect-ratios/${ratio}/rim-diameters`, {category}).pipe(
      map(response => response.data)
    );
  }
}
